/**
 * ESM facade for @x9/phone-e164 — implementation in index.cjs.
 */
import mod from './index.cjs';

export const {
  BR_DIAL_CODE,
  DEFAULT_DIAL_CODE,
  BR_AREA_CODES,
  digitsOf,
  isBrazilianMobile,
  addMissingNinthDigit,
  brazilianNational,
  toE164,
  isPlausiblePhone,
  phoneInputProblem,
} = mod;

export default mod;
